<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="1" :tab="$t('tab.disqualificationOrder')" style="margin-top: -14px">
        <disqualification-destory-confirm-table ref="disqualificationDestoryConfirmTable" @dblclick="dblclick"/>
      </a-tab-pane>
      <a-tab-pane key="2" :tab="$t('tab.orderDetail')" forceRender style="margin-top: -14px">
        <disqualification-destory-confirm-detail ref="disqualificationDestoryConfirmDetail" @failed="failed" @success="success"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-button type="primary" @click="query">{{ $t('button.query') }}</a-button>
        <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
        <a-button :disabled="approveDisabled" :loading="approveLoading" type="primary" @click="approve">{{ $t('button.approve') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>

<script>
  import DisqualificationDestoryConfirmTable from '@/views/quality_control/disqualification_manage/disqualification_destory_confirm/DisqualificationDestoryConfirmTable.vue'
  import DisqualificationDestoryConfirmDetail from '@/views/quality_control/disqualification_manage/disqualification_destory_confirm/DisqualificationDestoryConfirmDetail.vue'

  export default {
    name: 'DisqualificationDestoryConfirm',
    components: {
      DisqualificationDestoryConfirmDetail,
      DisqualificationDestoryConfirmTable
    },
    data() {
      return {
        activeKey: '1',
        approveLoading: false,
        rejectLoading: false,
        approveDisabled: true,
        rejectDisabled: true
      }
    },
    watch: {
      activeKey: {
        handler(newVal) {
          if (newVal === '1') {
            this.approveDisabled = true
            this.rejectDisabled = true
          } else {
            this.approveDisabled = false
            this.rejectDisabled = false
          }
        }
      }
    },
    methods: {
      dblclick(record) {
        this.activeKey = '2'
        this.$refs.disqualificationDestoryConfirmDetail.getData(record)
      },
      approve() {
        this.approveLoading = true
        this.$refs.disqualificationDestoryConfirmDetail.approve()
      },
      query() {
        if (this.activeKey === '1') {
          this.$refs.disqualificationDestoryConfirmTable.getData()
        } else {
          this.$refs.disqualificationDestoryConfirmDetail.getData()
        }
      },
      reset() {
        this.$refs.disqualificationDestoryConfirmTable.reset()
        this.$refs.disqualificationDestoryConfirmDetail.clear()
      },
      success() {
        this.approveLoading = false
        this.rejectLoading = false
        this.$refs.disqualificationDestoryConfirmTable.getData()
        this.$refs.disqualificationDestoryConfirmDetail.clear()
      },
      failed() {
        this.approveLoading = false
        this.rejectLoading = false
      }
    }
  }
</script>
